
import { defineComponent, PropType } from 'vue';

const BuilderText = defineComponent({
  name: 'BuilderText',
  props: {
    /** html text to render - **Must contain `<p>` etc** */
    text: {
      type: String,
      default: null,
    },
    configuration: {
      type: Object as PropType<{fullscreen: boolean}>,
      default: () => {
        return {
          fullscreen: false,
        }
      },
    }
  },
});
export default BuilderText
